import { jsx as _jsx } from "react/jsx-runtime";
import tokenData from '../../design-tokens/base-tokens.json';
import Slide from '@mui/material/Slide';
function SlideTransition(props) {
    return _jsx(Slide, { ...props, direction: "right" });
}
export const MuiSnackbar = {
    defaultProps: {
        TransitionComponent: SlideTransition
    },
    styleOverrides: {
        root: {
            maxWidth: '344px'
        }
    }
};
export const MuiSnackbarContent = {
    styleOverrides: {
        root: ({ theme }) => ({
            backgroundColor: tokenData.tokens.palette.grey.grey700,
            borderRadius: '4px',
            minHeight: 36,
            padding: theme.spacing(3, 6, 3, 8),
            ...theme.typography.body1
        }),
        message: {
            color: tokenData.tokens.palette.background.white,
            padding: 0
        },
        action: {
            '& .MuiButton-root': {
                color: tokenData.tokens.palette.blue.blue300,
                fontSize: '0.875rem'
            },
            '& .MuiIconButton-root': {
                color: tokenData.tokens.palette.background.white
            }
        }
    }
};
